<div class="container" [class.open]="isOpen()">
  <header>
    <div (click)="checkToggle()" [class.inactive]="!isActive">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
    <div class="label" (click)="collapseToggle()" [class.inactive]="!isActive">
      <div
        #editableSpan
        [attr.contenteditable]="false"
        [textContent]="label"
        (keypress)="onEnterPress($event)"
        (blur)="editModeExit($event)"
      ></div>
      <span *ngIf="isEditable && !editMode" (click)="onChangeClick($event)">
        (Change)
      </span>
    </div>
    <div class="button" (click)="collapseToggle()">
      <div class="close" [hidden]="index">
        <svg viewBox="0 0 13.02 14.02">
          <path
            fill-rule="evenodd"
            d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
          />
        </svg>
      </div>
      <div class="open" [hidden]="!index">
        <svg viewBox="2 0 13.02 14.02">
          <path
            fill-rule="evenodd"
            d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
          />
        </svg>
      </div>
    </div>
    <div class="trash-icon" [inlineSVG]="trashIcon" (click)="onDelete()"></div>
  </header>
  <div class="content">
    <ng-content *ngIf="index === 1"></ng-content>
  </div>
</div>
